






































































































































































































































import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
import confirmDialog from '@/components/common/confirmDialog.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import TruncatedText from '@/components/Truncate.vue';
import * as api from '@/api';
import { TrainClassDto, TrainingScheduling } from '@/api/models';
import moment from 'moment';
import { isNull } from 'lodash';
import SessionModule from '@/store/modules/session';
import { Dialog, Notify } from 'vant';
import UserModule from '@/store/modules/user';
import axios from 'axios';

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);

@Component({ components: { confirmDialog, confirmFeedback, TruncatedText } })
export default class ClassInfoIndex extends Vue {
  @Prop() isDetail: boolean;
  @Prop() trainStatus: string;
  //首页培训中
  @Prop() inTraining: boolean;
  //首页报到中
  @Prop() signingUp: boolean;

  @Prop() title: string;

  @Prop() currentClass: any;

  @Prop() trainingScheduling: TrainingScheduling[];
  @Watch('trainingScheduling', { deep: true, immediate: true })
  onTrainingSchedulingAsync(val: any) {
    this.trainingSchedulingData = val;
  }

  @Watch('currentClass', { deep: true, immediate: true })
  onCurrentClassChangeAsync(val: any) {
    this.classItem = val;
    this.attachmentData = [];
    this.stayObj = {
      number: '',
      remark: '',
    };
    this.findStay();
    if (this.classItem.studentManualKey) this.getAttachment('学员手册', this.classItem.studentManualKey);
  }
  @Watch('trainStatus', { deep: true, immediate: true })
  async TrainStatus(val: string) {
    this.crrTrainStatus = val;
  }
  @Watch('isDetail', { deep: true, immediate: true })
  onJudgeIsDetail(val: boolean) {
    if (val) {
      this.detailOrNo = val;
    }
  }

  stayObj: any = {
    number: '',
    remark: '',
  }; // 住宿信息

  showPopover: boolean = false; // 住宿备注信息旗袍

  detailOrNo: boolean = false;
  crrTrainStatus: string = '';
  loading: boolean = false;
  finished: boolean = false;
  dialogShow: boolean = false;
  feedbackShow: boolean = false;
  errorMsg: string = '';
  dialogType: string = '';
  feedbackType: string = '';
  successStatu: boolean = false;
  //时间、地点签到确认框专用
  signTime: string = '';
  signAddress: string = '';
  // signList: ClassSolutionSignInSchedule[] = [];
  trainingSchedulingData: TrainingScheduling[] = [];
  classItem: any = {
    id: '',
    className: '',
    deptName: '',
    address: '',
    trainType: '',
    days: 0,
    startClassDate: '',
    endClassDate: '',
    content: '',
    runClassType: '',
    objectScope: '',
    number: 0,
    schedulingAttachmentKey: '',
  };
  solutionId: string = '';

  attachmentData: any = [];

  // courseCounts: number = 0;

  get courseCounts() {
    let count = 0;
    if (this.classItem) {
      this.classItem?.trainingSchedulings?.length;
    }
    return count;
  }

  get totalHours() {
    let hour = 0;
    const res = (hour += this.classItem.days);
    return res ?? 0;
  }

  noManual() {
    Notify({ type: 'warning', message: '暂未上传' });
  }

  /**查找住宿信息 */
  async findStay() {
    const { data, success } = await api.Room.findByClassIdAndName_GET({ classId: this.classItem.id });
    if (success) this.stayObj = { number: data.number, remark: data.remark };
  }

  async getAttachment(keyName, key) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.attachmentData = data;
  }

  async toDetail() {
    //报到中
    if (this.$route.name != 'signUpDetail') {
      if (this.signingUp) {
        this.crrTrainStatus = '报到中';
        let classIds = [];
        classIds.push(this.classItem.id);
        await this.getStudentAuditStatus(classIds, this.classItem);
        this.$router.push({
          name: 'signUpDetail',
          params: { classItem: JSON.stringify(this.classItem) },
        });
      }
    }

    let classItem = JSON.stringify(this.classItem);
    //判断当前路由是否为培训班详情页
    if (this.$route.name != 'trainingDetail' && !this.signingUp) {
      //首页培训中
      if (this.inTraining) {
        this.crrTrainStatus = '培训中';
      }
      this.$router.push({
        name: 'trainingDetail',
        params: {
          trainStatus: this.crrTrainStatus,
          title: this.title,
          classItem: classItem,
        },
      });
    }
  }

  /**取消报道 */
  async cancelSigning() {
    Dialog.confirm({
      message: '确认取消报到？',
      theme: 'round-button',
    })
      .then(async () => {
        await api.TrainRecords.cancelSignin_POST({ classId: this.classItem.id, classType: this.classItem.classType });
        this.$emit('delete-train', this.classItem.id);
        Notify({ type: 'success', message: '取消成功' });
      })
      .catch(() => {
        // Notify({ type: 'danger', message: '取消失败' });
      });
  }

  //签到点击事件
  signSubmit() {
    //点击签到时，获取当前培训班所有的签到时间段列表
    this.getSignList(this.classItem.id!);
    this.dialogShow = true;
    this.dialogType = '签到';
    this.signTime = moment(new Date()).format('YYYY-MM-DD HH:mm');
    this.signAddress = this.classItem.address!;
  }
  //确认签到或报到回调事件
  async confirmSubmit(val: any) {
    this.dialogShow = false;
    // if (this.dialogType == "签到") {
    //   //判断当前时间是否在签到列表所设置的签到开始与截止时间内（是：允许签到，否：不允许签到）
    //   if (this.signList) {
    //     this.signList.forEach(async (item, index) => {
    //       //当前签到时间在签到时间段内时，允许签到，将签到记录存储到签到记录表
    //       this.loading = true;
    //       //系统返回提交状态
    //       try {
    //         const {
    //           data,
    //           success,
    //           message,
    //         } = await api.SolutionSignIn.studentSingIn_POST({
    //           openClassSolutionId: item.openClassSolutionId,
    //           signInScheduleId: "",
    //         });
    //         if (success) {
    //           this.successStatu = true;
    //           this.feedbackShow = true;
    //         } else {
    //           this.successStatu = false;
    //           this.errorMsg = "当前时间不在签到时间段内";
    //           this.feedbackShow = true;
    //         }
    //       } finally {
    //         this.loading = false;
    //         this.finished = true;
    //       }
    //     });
    //   }
    //   if (!this.successStatu) {
    //     this.errorMsg = "当前时间不在签到时间段内";
    //   }

    //   this.feedbackType = "签到";
    // }
    if (this.dialogType == '报到') {
      //系统返回提交状态
      try {
        const { data, success, message } = await api.TrainRecords.classSignin_POST({
          classId: this.solutionId,
          classType: this.classItem.classType,
        });
        if (success) {
          this.successStatu = true;
          this.$emit('signUpSuccess', this.classItem);
          this.feedbackShow = true;
        } else {
          this.successStatu = false;
          this.errorMsg = message;
          this.feedbackShow = true;
        }
      } finally {
        this.loading = false;
        this.finished = true;
      }
      this.feedbackType = '报到';
      // setTimeout(() => {
      //   this.feedbackShow = false;
      // }, 3000);
    }
  }
  //取消签到或报到回调事件
  confirmCancle() {
    this.dialogShow = false;
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
  //获取签到列表
  async getSignList(openClassSolutionId: string) {
    // const { data } = await api.SolutionSignIn.getSignInList_GET({
    //   openClassSolutionId: openClassSolutionId,
    // });
    // this.signList = data!;
  }
  //报到点击事件
  onSignUp(solutionId: string) {
    this.dialogShow = true;
    this.dialogType = '报到';
    this.solutionId = solutionId;
  }

  //获取学员对应培训班的报到审核状态
  async getStudentAuditStatus(classIds: any, classItem: any) {
    const { data } = await api.ClassSolution.getStudentAuditStatus_GET({
      studentId: SessionModule.getActiveSession.userId,
      classIds: classIds,
    });
    if (data) {
      data.forEach((stuAuditItem: any) => {
        if (stuAuditItem.classId == classItem.id) {
          classItem.studentAuditStatu = stuAuditItem.studentAuditStatu;
        }
      });
    }
  }

  //跳转到全部日程详情
  toScheduleDetail() {
    //处理全部日程列表
    let trainingList: any = [];
    let classItem = this.classItem;
    let trainingSchedulings = classItem.trainingSchedulings;
    if (trainingSchedulings.length > 0) {
      trainingSchedulings.forEach((trainItem: any) => {
        let trainObject: any = {};
        trainObject.openClassSolutionId = classItem.id;
        trainObject.className = classItem.className;
        trainObject.deptId = classItem.deptId;
        trainObject.trainType = classItem.trainType;
        trainObject.trainingSchedulingId = trainItem.id;
        trainObject.courseName = trainItem.courseName;
        trainObject.teacherId = trainItem.systemTeacherId;
        trainObject.teacher = trainItem.teacher;
        trainObject.teacherJob = trainItem.teacherJob;
        trainObject.hours = trainItem.hours;
        trainObject.unitName = trainItem.unitName;
        trainObject.trainingDate = trainItem.trainingDate;
        trainObject.trainingTime = trainItem.trainingTime;
        trainObject.trainingStartTime = trainItem.trainingStartTime;
        trainObject.trainingEndTime = trainItem.trainingEndTime;
        trainingList.push(trainObject);
      });
    }
    this.$router.push({
      name: 'schedule',
      params: {
        trainingSchedulings: JSON.stringify(trainingList),
      },
    });
  }

  //#region 生成培训记录
  async buildRecord() {}

  //跳转到综合评价
  toComprehensiveDetail() {
    let comprehensiveObject: any = {};
    let classItem = this.classItem;
    comprehensiveObject.className = classItem.className;
    comprehensiveObject.createdOn = classItem.createdOn;
    comprehensiveObject.deptId = classItem.deptId;
    comprehensiveObject.deptName = classItem.deptName;
    comprehensiveObject.endClassDate = classItem.endClassDate;
    comprehensiveObject.endSignUpDate = classItem.endSignUpDate;
    comprehensiveObject.locationCategory = classItem.locationCategory;
    comprehensiveObject.openClassSolutionId = classItem.id;
    comprehensiveObject.runClassType = classItem.runClssType;
    comprehensiveObject.startClassDate = classItem.startClassDate;
    comprehensiveObject.startSignUpDate = classItem.startSignUpDate;
    comprehensiveObject.trainType = classItem.trainType;
    comprehensiveObject.trainingAgencyId = classItem.trainingAgencyId;
    comprehensiveObject.trainingAgencyName = classItem.trainingAgencyName;

    let endClassDate = new Date(classItem.endDate);
    let dateTimeNow = new Date();
    if (endClassDate < dateTimeNow) {
      this.$router.push({
        name: 'feedback',
        params: { feedbackTitle: '综合评价', comprehensiveDetail: comprehensiveObject },
      });
    } else {
      Dialog.alert({
        message: '当前培训班培训还未结束，不能评价！',
      });
    }
  }
  //跳转到心得评价
  toExperience() {
    // let className = this.classItem.className;
    // let solutionId = this.classItem.id;
    this.$router.push({
      name: 'experienceForm',
      query: { classItem: JSON.stringify(this.classItem), type: '未提交' },
    });
  }
  toReport() {
    Notify({
      message: '目前只支持扫码报到。',
    });
  }
}
